import { ROOMVO_SCRIPT, ROOMVO_SCRIPT_TAG_ID } from '@/components/content/ProductDetails/constants';
import React, { useEffect } from 'react';

interface RoomvoContainerProps {
	sku: string | undefined;
	enabled: boolean;
	productType: 'floor' | 'wall' | 'rug';
	children: React.ReactNode | undefined;
}
export const RoomvoContainer = ({ sku, enabled, productType, children }: RoomvoContainerProps) => {
	useEffect(() => {
		if (!enabled) return;
		if (document.getElementById(ROOMVO_SCRIPT_TAG_ID)) return;

		const script = document.createElement('script');
		script.src = ROOMVO_SCRIPT;
		script.id = ROOMVO_SCRIPT_TAG_ID;
		script.async = true;

		document.head.appendChild(script);

		return () => {
			document.getElementById(ROOMVO_SCRIPT_TAG_ID)?.remove();
		};
	}, [enabled]);

	if (!enabled || !sku) return null;

	return (
		<div className="roomvo-container" data-sku={sku} data-product-type-str={productType}>
			<div
				className="roomvo-stimr"
				style={{ visibility: 'hidden' }} // required by documentation
				data-sku={sku}
				data-roomvo-product-code={sku}
				data-roomvo-vendor-code={sku}
				role="button"
			>
				{children}
			</div>
		</div>
	);
};
